var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcc1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00005 6.97578C5.86672 6.97578 5.73738 6.95078 5.61205 6.90078C5.48672 6.85078 5.38272 6.78411 5.30005 6.70078L0.700048 2.10078C0.516715 1.91745 0.425049 1.68411 0.425049 1.40078C0.425049 1.11745 0.516715 0.884114 0.700048 0.700781C0.883382 0.517448 1.11672 0.425781 1.40005 0.425781C1.68338 0.425781 1.91672 0.517448 2.10005 0.700781L6.00005 4.60078L9.90005 0.700781C10.0834 0.517448 10.3167 0.425781 10.6 0.425781C10.8834 0.425781 11.1167 0.517448 11.3 0.700781C11.4834 0.884114 11.575 1.11745 11.575 1.40078C11.575 1.68411 11.4834 1.91745 11.3 2.10078L6.70005 6.70078C6.60005 6.80078 6.49172 6.87178 6.37505 6.91378C6.25838 6.95578 6.13338 6.97645 6.00005 6.97578Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcc1);
export default __webpack_public_path__ + "static/media/acc1.0ae273a30ae7a69c5734e1d30e05af7d.svg";
export { ForwardRef as ReactComponent };